import axios from "axios";
const url = window.location.hostname;


// eslint-disable-next-line no-restricted-globals
const protocol = location.protocol;
const api = axios.create({
    baseURL: protocol + "//" + url
})

export default api;